import { Popover } from "@material-ui/core";
import styled from "styled-components";
import { COLORS, FONTS } from "Styles/Constants";

export const FilterWrapper = styled.div`
  height: 70px;
  display: flex;
  flex-direction: column;
  .heading {
    margin-left: 20px;
    color: #132c51;
    font-size: 16px;
    font-weight: bolder;
    padding: 5px;
    @media only screen and (max-width: 940px) {
      font-size: 14px;
    }
  }
  .filter-container {
    display: flex;
    justify-content: space-evenly;
    gap: 8px;
    padding: 5px;
    @media only screen and (max-width: 940px) {
      gap: 10px;
      padding: 0px 15px;
    }
    @media only screen and (max-width: 850px) {
      overflow-x: auto;
      overflow-y: hidden;
      justify-content: flex-start;
      gap: 10px;
      ::-webkit-scrollbar {
        display: none;
      }
    }
    .e-bin-markers-list-container {
      display: flex;
      align-items: center;
      gap: 5px;
      @media only screen and (max-width: 940px) {
        width: 140px;
      }
      .checkbox {
        width: 15px;
        height: 15px;
      }
      .text {
        margin-left: 5px;
        font-size: 14px;
        font-weight: 600;
        color: black;
        @media only screen and (max-width: 940px) {
          font-size: 12px;
          width: 50px;
        }
        @media only screen and (max-width: 850px) {
          width: 50px;
        }
      }
      .image-icon {
        margin-top: 3px;
        margin-left: 3px;
        .odd-image {
          width: 35px;
          height: 40px;
          @media only screen and (max-width: 940px) {
            width: 20px;
            height: 25px;
          }
        }
        .even-image {
          width: 25px;
          height: 40px;
          @media only screen and (max-width: 940px) {
            width: 20px;
            height: 25px;
          }
        }
      }
      .MuiIconButton-root {
        padding: 0px;
      }
    }
    .info-icon {
      margin-top: -25px;
      margin-left: 0px;
    }
  }
`;

export const StyledPopover = styled(Popover)`
  && {
    z-index: 1200;

    .popover-content {
      background-color: white;
      color: black;
      height: max-content;
      width: 300px;
      border-radius: 10px;
    }

    .popover-paper {
      overflow-x: unset;
      overflow-y: unset;
      border-radius: 10px;

      &::before {
        content: "";
        position: absolute;
        top: -20px;
        right: 20px;
        border-bottom: 10px solid black;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        border-top: 10px solid transparent;
        // z-index: 1300;

        margin-right: -0.71em;
        // bottom: 0;
        // right: 0;
        width: 10px;
        height: 10px;
        background-color: white;
        transform: translate(-50%, 50%) rotate(-45deg);
        clip-path: polygon(
          -5px -5px,
          calc(100% + 5px) -5px,
          calc(100% + 5px) calc(100% + 5px)
        );
      }

      .filter-container {
        padding-top: 0;
        padding-bottom: 0;
        .filter-box-container {
          justify-content: space-between;
          align-items: flex-start;
          /* color: ${COLORS.APP_SECONCARY}; */

          .filter-favourite-text {
            /* color: ${COLORS.APP_SECONCARY}; */
            font-weight: 600;
            /* font-family: ${FONTS.PRIMARY}; */
          }

          .e-bin-markers-list-container {
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 15px;
            .image-icon {
              margin-left: auto;
              margin-right: 15px;
            }
          }

          .markers-list-container {
            .markers-list-checkbox {
              padding: 5px;
              /* color: ${COLORS.APP_TERTIRY} */
            }
            .markers-list-text {
              font-size: 16px;
              font-weight: 500;
              font-family: ${FONTS.PRIMARY};
            }

            .sub {
              margin: 0 0 0 10px;
            }
          }
        }
        .filter-header-container {
          /* color: ${COLORS.APP_TERTIRY}; */

          .filter-header-icon {
            /* color: ${COLORS.APP_TERTIRY} */
          }
          .filter-header-text {
            font-weight: bold;
            font-size: 16px;
            /* font-family: ${FONTS.PRIMARY}; */
          }
        }

        .filter-save-button {
          font-size: 16px;
          font-weight: 500;
          padding-bottom: 5px;
          /* font-family: ${FONTS.PRIMARY}; */
        }
      }

      .filter-divider {
        height: 0;
        opacity: 0.3;
        border: solid 1px #7bc8a9;
      }
    }
  }
`;
